import React, { useEffect, useState } from "react";
import TopNavigation from "../../layouts/top-navigation/TopNavigation";
import TaskTable from "./Components/TaskTable";
import InsightSidebar from "../../components/InsightSidebar";
import ScreeningHistory from "../Screening/ScreeningHistory";
import InterviewHistory from "../Interview/InterviewHistory";
import BottomNavigation from "../../layouts/bottom-navigation/BottomNavigation";


const InsightsContainer = () => {


  const [active, setActive] = useState<string>("/tasks");

  useEffect(() => {
    setActive("/tasks");
  }, []);

  return (
    <div id="screen-wrapper">
      <TopNavigation />
      <InsightSidebar setActive={setActive} />
      <BottomNavigation />
      <main>
        <div>
          {active === "/tasks" && <TaskTable pageHeader={"My Tasks"} />}
          {active === "/screeninghistory" && <ScreeningHistory />}
          {active === "/evaluationhistory" && <InterviewHistory />}
        </div>
      </main>
    </div>
  );
};

export default InsightsContainer;
